<template lang="html">
  <error-page-layout
    color-type="error"
    error-type="Sessão finalizada"
    first-message="Você excedeu o limite de sessões simultâneas e foi desconectado."
    image-name="disconnected.png"
    title="Você foi desconectado"
  >
    <v-btn slot="buttons" color="orange" dark text>Fazer login novamente</v-btn>
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
}
</script>
